<script setup>
import Toggle from "@vueform/toggle/src/Toggle.vue";

const model = defineModel({
  type: [Boolean],
});

</script>
<template>
  <Toggle
    v-model="model"
    :classes="{
      container: 'tw-inline-block tw-rounded-full tw-outline-none',
      toggle: 'tw-flex tw-w-[51px] tw-h-[26px] tw-rounded-full tw-relative tw-cursor-pointer tw-transition tw-items-center tw-box-content tw-border-2 tw-text-xs tw-leading-none',
      toggleOn: 'tw-bg-primary tw-border-primary tw-text-neutral',
      toggleOff: 'tw-bg-primary-300 tw-border-primary-300 tw-text-neutral',
      handle: 'tw-inline-block tw-bg-white tw-w-[24px] tw-h-[24px] tw-rounded-full tw-absolute tw-transition-all',
      handleOn: 'tw-left-full tw-transform -tw-translate-x-full',
      handleOff: 'tw-left-0',
    }"
  />
</template>

